import type { KeyboardEvent } from "react"

/**
 * Activates a focusable row on Enter or Space. Keys pressed on a control
 * inside the row belong to that control and are ignored. An activating key is
 * consumed, so page-level shortcuts bound to the same key do not also run.
 */
export function handleAccessibleRowKeyDown(
  event: KeyboardEvent,
  onActivate: () => void,
) {
  if (event.target !== event.currentTarget) {
    return
  }

  if (event.key === "Enter" || event.key === " ") {
    event.preventDefault()
    event.stopPropagation()
    onActivate()
  }
}
